import {Action} from '../../actions/index';
import {ActionTypes, LookupBsbResponse} from './types';

export interface LookupState {
  bsbInfo?: LookupBsbResponse;
  fetchedBsbInfo: boolean;
}

const initialState: LookupState = {
  bsbInfo: {
    bsbInfo: [],
    statusCode: undefined,
    message: undefined
  },
  fetchedBsbInfo: false
};

const LookupReducer = (state: LookupState = initialState, action: Action): LookupState => {
  switch (action.type) {
    case ActionTypes.FETCH_BSB_LOOKUP_PENDING: {
      return {
        ...state,
        fetchedBsbInfo: false
      };
    }
    case ActionTypes.FETCH_BSB_LOOKUP_FULFILLED: {
      return {
        ...state,
        fetchedBsbInfo: true,
        bsbInfo: action.payload as LookupBsbResponse
      };
    }
    default: {
      return state;
    }
  }
};

export default LookupReducer;
